import Component from "../../lib/Component.js";

/**
 * AdBlockNotice component
 *
 * Listens to the consentPromise and triggers a notice if the CMP script
 * was detected as blocked (typically by an ad-blocker).
 *
 * @param {Promise} consentPromise - The promise resolving with consent data and reason
 * @param {Object} options
 * @param {Function} options.onDetected - Callback to trigger when adblock is detected
 * @returns {Component}
 */
const AdBlockNotice = (consentPromise, { onDetected }) => {
  return new Component({
    onMount: async () => {
      const { reason } = await consentPromise;
      if (process.env.NODE_ENV === "development") {
        if (reason === "dev-mode") {
          console.info("AdBlockNotice: Dev mode - simulating adblock detection");
          // if (onDetected) onDetected();
        }
      }
      if (reason === "cmp-blocked" && onDetected) {
        onDetected();
      }
    },
  });
};

export default AdBlockNotice;
